//API
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const TOGGLE_APP_DRAWER = 'toggle_app_drawer';
export const UPDATING_CONTENT = 'updating_content';

//APP SETTING
export const TOGGLE_NAV_COLLAPSED = 'toggle_nav_collapsed';
export const SET_INITIAL_PATH = 'set_initial_path';

//AUTH0
export const UPDATE_AUTH_USER = 'update_auth_user';
export const SET_AUTH_TOKEN = 'set_auth_token';
export const SIGNOUT_AUTH_SUCCESS = 'signout_auth_success';

// ROLES
export const GET_COLECCION_ROL = 'get_coleccion_rol';
export const GET_COLECCION_LIGERA_ROL = 'get_coleccion_ligera_rol';
export const GET_PERMISOS = 'get_permisos';
export const OTORGAR_PERMISO = 'otorgar_permiso';
export const REVOCAR_PERMISO = 'revocar_permiso';
export const SHOW_ROL = 'show_rol';
export const UPDATE_ROL = 'update_rol';
export const CREATE_ROL = 'create_rol';
export const DELETE_ROL = 'delete_rol';

// APLICACIONES
export const GET_COLECCION_APLICACION = 'get_coleccion_aplicacion';
export const GET_COLECCION_LIGERA_APLICACION = 'get_coleccion_ligera_aplicacion';
export const SHOW_APLICACION = 'show_aplicacion';
export const UPDATE_APLICACION = 'update_aplicacion';
export const CREATE_APLICACION = 'create_aplicacion';
export const DELETE_APLICACION = 'delete_aplicacion';

// MODULOS
export const GET_COLECCION_MODULO = 'get_coleccion_modulo';
export const GET_COLECCION_LIGERA_MODULO = 'get_coleccion_ligera_modulo';
export const SHOW_MODULO = 'show_modulo';
export const UPDATE_MODULO = 'update_modulo';
export const CREATE_MODULO = 'create_modulo';
export const DELETE_MODULO = 'delete_modulo';

// USUARIOS
export const GET_COLECCION_USUARIO = 'get_coleccion_USUARIO';
export const GET_COLECCION_LIGERA_USUARIO = 'get_coleccion_ligera_usuario';
export const SHOW_USUARIO = 'show_usuario';
export const UPDATE_USUARIO = 'update_usuario';
export const CREATE_USUARIO = 'create_usuario';
export const DELETE_USUARIO = 'delete_usuario';

// OPCIONES DEL SISTEMA
export const GET_COLECCION_OPCION_SISTEMA = 'get_coleccion_opcion_sistema';
export const GET_COLECCION_LIGERA_OPCION_SISTEMA = 'get_coleccion_ligera_opcion_sistema';
export const SHOW_OPCION_SISTEMA = 'show_opcion_sistema';
export const UPDATE_OPCION_SISTEMA = 'update_opcion_sistema';
export const CREATE_OPCION_SISTEMA = 'create_opcion_sistema';
export const DELETE_OPCION_SISTEMA = 'delete_opcion_sistema';

// PERMISOS
export const GET_COLECCION_PERMISO = 'get_coleccion_permiso';
export const GET_COLECCION_LIGERA_PERMISO = 'get_coleccion_ligera_permiso';
export const SHOW_PERMISO = 'show_permiso';
export const UPDATE_PERMISO = 'update_permiso';
export const CREATE_PERMISO = 'create_permiso';
export const DELETE_PERMISO = 'delete_permiso';

// AUDITORÍA
export const GET_COLECCION_CONSULTA_AUDITORIA =
  'get_coleccion_consulta_auditoria';

// AUDITORÍA PROCESOs
export const GET_COLECCION_AUDITORIA_PROCESO =
  'get_coleccion_auditoria_proceso';

// PERSONAS
export const GET_COLECCION_PERSONA = 'get_coleccion_persona';
export const GET_COLECCION_LIGERA_PERSONA = 'get_coleccion_ligera_persona';
export const SHOW_PERSONA = 'show_persona';
export const UPDATE_PERSONA = 'update_persona';
export const CREATE_PERSONA = 'create_persona';
export const DELETE_PERSONA = 'delete_persona';

// FAMILIAS
export const GET_COLECCION_FAMILIA = 'get_coleccion_familia';
export const GET_COLECCION_LIGERA_FAMILIA = 'get_coleccion_ligera_familia';
export const SHOW_FAMILIA = 'show_familia';
export const UPDATE_FAMILIA = 'update_familia';
export const CREATE_FAMILIA = 'create_familia';
export const DELETE_FAMILIA = 'delete_familia';

// BENEFACTOR
export const GET_COLECCION_BENEFACTOR = 'get_coleccion_benefactor';
export const GET_COLECCION_LIGERA_BENEFACTOR = 'get_coleccion_ligera_benefactor';
export const SHOW_BENEFACTOR = 'show_benefactor';
export const UPDATE_BENEFACTOR = 'update_benefactor';
export const CREATE_BENEFACTOR = 'create_benefactor';
export const DELETE_BENEFACTOR = 'delete_benefactor';

// TIPO IDENTIFICACION
export const GET_COLECCION_TIPO_IDENTIFICACION = 'get_coleccion_tipo_identificacion';
export const GET_COLECCION_LIGERA_TIPO_IDENTIFICACION = 'get_coleccion_ligera_tipo_identificacion';
export const SHOW_TIPO_IDENTIFICACION = 'show_tipo_identificacion';
export const UPDATE_TIPO_IDENTIFICACION = 'update_tipo_identificacion';
export const CREATE_TIPO_IDENTIFICACION = 'create_tipo_identificacion';
export const DELETE_TIPO_IDENTIFICACION = 'delete_tipo_identificacion';

// PROYECTOS
export const GET_COLECCION_PROYECTO = 'get_coleccion_proyecto';
export const GET_COLECCION_LIGERA_PROYECTO = 'get_coleccion_ligera_proyecto';
export const SHOW_PROYECTO = 'show_proyecto';
export const UPDATE_PROYECTO = 'update_proyecto';
export const CREATE_PROYECTO = 'create_proyecto';
export const DELETE_PROYECTO = 'delete_proyecto';

// TIPO PARENTESCO
export const GET_COLECCION_TIPO_PARENTESCO = 'get_coleccion_tipo_parentesco';
export const GET_COLECCION_LIGERA_TIPO_PARENTESCO = 'get_coleccion_ligera_tipo_parentesco';
export const SHOW_TIPO_PARENTESCO = 'show_tipo_parentesco';
export const UPDATE_TIPO_PARENTESCO = 'update_tipo_parentesco';
export const CREATE_TIPO_PARENTESCO = 'create_tipo_parentesco';
export const DELETE_TIPO_PARENTESCO = 'delete_tipo_parentesco';

// TIPO DISCAPACIDAD
export const GET_COLECCION_TIPO_DISCAPACIDAD = 'get_coleccion_tipo_discapacidad';
export const GET_COLECCION_LIGERA_TIPO_DISCAPACIDAD = 'get_coleccion_ligera_tipo_discapacidad';
export const SHOW_TIPO_DISCAPACIDAD = 'show_tipo_discapacidad';
export const UPDATE_TIPO_DISCAPACIDAD = 'update_tipo_discapacidad';
export const CREATE_TIPO_DISCAPACIDAD = 'create_tipo_discapacidad';
export const DELETE_TIPO_DISCAPACIDAD = 'delete_tipo_discapacidad';

// TIPO ASESORIA
export const GET_COLECCION_TIPO_ASESORIA = 'get_coleccion_tipo_asesoria';
export const GET_COLECCION_LIGERA_TIPO_ASESORIA = 'get_coleccion_ligera_tipo_asesoria';
export const SHOW_TIPO_ASESORIA = 'show_tipo_asesoria';
export const UPDATE_TIPO_ASESORIA = 'update_tipo_asesoria';
export const CREATE_TIPO_ASESORIA = 'create_tipo_asesoria';
export const DELETE_TIPO_ASESORIA = 'delete_tipo_asesoria';

// ORIENTADORES
export const GET_COLECCION_ORIENTADOR = 'get_coleccion_orientador';
export const GET_COLECCION_LIGERA_ORIENTADOR = 'get_coleccion_ligera_orientador';
export const SHOW_ORIENTADOR = 'show_orientador';
export const UPDATE_ORIENTADOR = 'update_orientador';
export const CREATE_ORIENTADOR = 'create_orientador';
export const DELETE_ORIENTADOR = 'delete_orientador';

// PERSONA ASESORIA
export const GET_COLECCION_PERSONA_ASESORIA = 'get_coleccion_persona_asesoria';
export const GET_COLECCION_LIGERA_PERSONA_ASESORIA = 'get_coleccion_ligera_persona_asesoria';
export const SHOW_PERSONA_ASESORIA = 'show_persona_asesoria';
export const UPDATE_PERSONA_ASESORIA = 'update_persona_asesoria';
export const CREATE_PERSONA_ASESORIA = 'create_persona_asesoria';
export const DELETE_PERSONA_ASESORIA = 'delete_persona_asesoria';

// TIPO PROGRAMA
export const GET_COLECCION_TIPO_PROGRAMA = 'get_coleccion_tipo_programa';
export const GET_COLECCION_LIGERA_TIPO_PROGRAMA = 'get_coleccion_ligera_tipo_programa';
export const SHOW_TIPO_PROGRAMA = 'show_tipo_programa';
export const UPDATE_TIPO_PROGRAMA = 'update_tipo_programa';
export const CREATE_TIPO_PROGRAMA = 'create_tipo_programa';
export const DELETE_TIPO_PROGRAMA = 'delete_tipo_programa';

// PAIS
export const GET_COLECCION_PAIS = 'get_coleccion_pais';
export const GET_COLECCION_LIGERA_PAIS = 'get_coleccion_ligera_pais';
export const SHOW_PAIS = 'show_pais';
export const UPDATE_PAIS = 'update_pais';
export const CREATE_PAIS = 'create_pais';
export const DELETE_PAIS = 'delete_pais';

// DEPARTAMENTO
export const GET_COLECCION_DEPARTAMENTO = 'get_coleccion_departamento';
export const GET_COLECCION_LIGERA_DEPARTAMENTO = 'get_coleccion_ligera_departamento';
export const SHOW_DEPARTAMENTO = 'show_departamento';
export const UPDATE_DEPARTAMENTO = 'update_departamento';
export const CREATE_DEPARTAMENTO = 'create_departamento';
export const DELETE_DEPARTAMENTO = 'delete_departamento';

// CIUDAD
export const GET_COLECCION_CIUDAD = 'get_coleccion_ciudad';
export const GET_COLECCION_LIGERA_CIUDAD = 'get_coleccion_ligera_ciudad';
export const SHOW_CIUDAD = 'show_ciudad';
export const UPDATE_CIUDAD = 'update_ciudad';
export const CREATE_CIUDAD = 'create_ciudad';
export const DELETE_CIUDAD = 'delete_ciudad';

// COMUNA
export const GET_COLECCION_COMUNA = 'get_coleccion_comuna';
export const GET_COLECCION_LIGERA_COMUNA = 'get_coleccion_ligera_comuna';
export const SHOW_COMUNA = 'show_comuna';
export const UPDATE_COMUNA = 'update_comuna';
export const CREATE_COMUNA = 'create_comuna';
export const DELETE_COMUNA = 'delete_comuna';

// BARRIO
export const GET_COLECCION_BARRIO = 'get_coleccion_barrio';
export const GET_COLECCION_LIGERA_BARRIO = 'get_coleccion_ligera_barrio';
export const SHOW_BARRIO = 'show_barrio';
export const UPDATE_BARRIO = 'update_barrio';
export const CREATE_BARRIO = 'create_barrio';
export const DELETE_BARRIO = 'delete_barrio';

// ESTADO CIVIL
export const GET_COLECCION_ESTADO_CIVIL = 'get_coleccion_estado_civil';
export const GET_COLECCION_LIGERA_ESTADO_CIVIL = 'get_coleccion_ligera_estado_civil';
export const SHOW_ESTADO_CIVIL = 'show_estado_civil';
export const UPDATE_ESTADO_CIVIL = 'update_estado_civil';
export const CREATE_ESTADO_CIVIL = 'create_estado_civil';
export const DELETE_ESTADO_CIVIL = 'delete_estado_civil';

// OCUPACION
export const GET_COLECCION_OCUPACION = 'get_coleccion_ocupacion';
export const GET_COLECCION_LIGERA_OCUPACION = 'get_coleccion_ligera_ocupacion';
export const SHOW_OCUPACION = 'show_ocupacion';
export const UPDATE_OCUPACION = 'update_ocupacion';
export const CREATE_OCUPACION = 'create_ocupacion';
export const DELETE_OCUPACION = 'delete_ocupacion';

// GRADOS ESCOLARIDAD
export const GET_COLECCION_GRADOS_ESCOLARIDAD = 'get_coleccion_grados_escolaridad';
export const GET_COLECCION_LIGERA_GRADOS_ESCOLARIDAD = 'get_coleccion_ligera_grados_escolaridad';
export const SHOW_GRADOS_ESCOLARIDAD = 'show_grados_escolaridad';
export const UPDATE_GRADOS_ESCOLARIDAD = 'update_grados_escolaridad';
export const CREATE_GRADOS_ESCOLARIDAD = 'create_grados_escolaridad';
export const DELETE_GRADOS_ESCOLARIDAD = 'delete_grados_escolaridad';

// EPS
export const GET_COLECCION_EPS = 'get_coleccion_eps';
export const GET_COLECCION_LIGERA_EPS = 'get_coleccion_ligera_eps';
export const SHOW_EPS = 'show_eps';
export const UPDATE_EPS = 'update_eps';
export const CREATE_EPS = 'create_eps';
export const DELETE_EPS = 'delete_eps';

// TIPO-FAMILIA
export const GET_COLECCION_TIPO_FAMILIA = 'get_coleccion_tipo_familia';
export const GET_COLECCION_LIGERA_TIPO_FAMILIA = 'get_coleccion_ligera_tipo_familia';
export const SHOW_TIPO_FAMILIA = 'show_tipo_familia';
export const UPDATE_TIPO_FAMILIA = 'update_tipo_familia';
export const CREATE_TIPO_FAMILIA = 'create_tipo_familia';
export const DELETE_TIPO_FAMILIA = 'delete_tipo_familia';
// Condiciones familia
export const GET_COLECCION_CONDICION_FAMILIA = 'get_condicion_familia';
export const GET_COLECCION_LIGERA_CONDICION_FAMILIA = 'get_coleccion_ligera_condicion_familia';
export const SHOW_CONDICION_FAMILIA = 'show_condicion_familia';
export const UPDATE_CONDICION_FAMILIA = 'update_condicion_familia';
export const CREATE_CONDICION_FAMILIA = 'create_condicion_familia';
export const DELETE_CONDICION_FAMILIA = 'delete_condicion_familia';

// TIPOS POBLACION TIPOS_POBLACION
export const GET_COLECCION_TIPOS_POBLACION = 'get_tipos_poblacion';
export const GET_COLECCION_LIGERA_TIPOS_POBLACION = 'get_coleccion_ligera_tipos_poblacion';
export const SHOW_TIPOS_POBLACION = 'show_tipos_poblacion';
export const UPDATE_TIPOS_POBLACION = 'update_tipos_poblacion';
export const CREATE_TIPOS_POBLACION = 'create_tipos_poblacion';
export const DELETE_TIPOS_POBLACION = 'delete_tipos_poblacion';

// TIPOS POBLACION TIPOS_VIVIENDA
export const GET_COLECCION_TIPOS_VIVIENDA = 'get_coleccion_tipos_vivienda';
export const GET_COLECCION_LIGERA_TIPOS_VIVIENDA = 'get_coleccion_ligera_tipos_vivienda';
export const SHOW_TIPOS_VIVIENDA = 'show_tipos_vivienda';
export const UPDATE_TIPOS_VIVIENDA = 'update_tipos_vivienda';
export const CREATE_TIPOS_VIVIENDA = 'create_tipos_vivienda';
export const DELETE_TIPOS_VIVIENDA = 'delete_tipos_vivienda';

// TIPOS POBLACION TIPOS_TECHO
export const GET_COLECCION_TIPOS_TECHO = 'get_coleccion_tipos_techo';
export const GET_COLECCION_LIGERA_TIPOS_TECHO = 'get_coleccion_ligera_tipos_techo';
export const SHOW_TIPOS_TECHO = 'show_tipos_techo';
export const UPDATE_TIPOS_TECHO = 'update_tipos_techo';
export const CREATE_TIPOS_TECHO = 'create_tipos_techo';
export const DELETE_TIPOS_TECHO = 'delete_tipos_techo';

// TIPOS POBLACION TIPOS_PISO
export const GET_COLECCION_TIPOS_PISO = 'get_coleccion_tipos_piso';
export const GET_COLECCION_LIGERA_TIPOS_PISO = 'get_coleccion_ligera_tipos_piso';
export const SHOW_TIPOS_PISO = 'show_tipos_piso';
export const UPDATE_TIPOS_PISO = 'update_tipos_piso';
export const CREATE_TIPOS_PISO = 'create_tipos_piso';
export const DELETE_TIPOS_PISO = 'delete_tipos_piso';

// TIPOS POBLACION TIPOS_DIVISION
export const GET_COLECCION_TIPOS_DIVISION = 'get_coleccion_tipos_division';
export const GET_COLECCION_LIGERA_TIPOS_DIVISION = 'get_coleccion_ligera_tipos_division';
export const SHOW_TIPOS_DIVISION = 'show_tipos_division';
export const UPDATE_TIPOS_DIVISION = 'update_tipos_division';
export const CREATE_TIPOS_DIVISION = 'create_tipos_division';
export const DELETE_TIPOS_DIVISION = 'delete_tipos_division';
// BANCO
export const GET_COLECCION_BANCO = 'get_coleccion_banco';
export const GET_COLECCION_LIGERA_BANCO = 'get_coleccion_ligera_banco';
export const SHOW_BANCO = 'show_banco';
export const UPDATE_BANCO = 'update_banco';
export const CREATE_BANCO = 'create_banco';
export const DELETE_BANCO = 'delete_banco';

// FORMAS DE PAGO
export const GET_COLECCION_FORMA_PAGO = 'get_coleccion_forma_pago';
export const GET_COLECCION_LIGERA_FORMA_PAGO = 'get_coleccion_ligera_forma_pago';
export const SHOW_FORMA_PAGO = 'show_forma_pago';
export const UPDATE_FORMA_PAGO = 'update_forma_pago';
export const CREATE_FORMA_PAGO = 'create_forma_pago';
export const DELETE_FORMA_PAGO = 'delete_forma_pago';

// TIPOS DOCUMENTOS PAGO
export const GET_COLECCION_TIPO_DOCUMENTO_PROYECTO = 'get_coleccion_tipo_documento_proyecto';
export const GET_COLECCION_LIGERA_TIPO_DOCUMENTO_PROYECTO = 'get_coleccion_ligera_tipo_documento_proyecto';
export const SHOW_TIPO_DOCUMENTO_PROYECTO = 'show_tipo_documento_proyecto';
export const UPDATE_TIPO_DOCUMENTO_PROYECTO = 'update_tipo_documento_proyecto';
export const CREATE_TIPO_DOCUMENTO_PROYECTO = 'create_tipo_documento_proyecto';
export const DELETE_TIPO_DOCUMENTO_PROYECTO = 'delete_tipo_documento_proyecto';

// TIPOS GASTOS
export const GET_COLECCION_TIPO_GASTO = 'get_coleccion_tipo_gasto';
export const GET_COLECCION_LIGERA_TIPO_GASTO = 'get_coleccion_ligera_tipo_gasto';
export const SHOW_TIPO_GASTO = 'show_tipo_gasto';
export const UPDATE_TIPO_GASTO = 'update_tipo_gasto';
export const CREATE_TIPO_GASTO = 'create_tipo_gasto';
export const DELETE_TIPO_GASTO = 'delete_tipo_gasto';

// TIPOS BENEFACTOR
export const GET_COLECCION_TIPO_BENEFACTOR = 'get_coleccion_tipo_benefactor';
export const GET_COLECCION_LIGERA_TIPO_BENEFACTOR = 'get_coleccion_ligera_tipo_benefactor';
export const SHOW_TIPO_BENEFACTOR = 'show_tipo_benefactor';
export const UPDATE_TIPO_BENEFACTOR = 'update_tipo_benefactor';
export const CREATE_TIPO_BENEFACTOR = 'create_tipo_benefactor';
export const DELETE_TIPO_BENEFACTOR = 'delete_tipo_benefactor';

// TIPOS DONACION
export const GET_COLECCION_TIPO_DONACION = 'get_coleccion_tipo_donacion';
export const GET_COLECCION_LIGERA_TIPO_DONACION = 'get_coleccion_ligera_tipo_donacion';
export const SHOW_TIPO_DONACION = 'show_tipo_donacion';
export const UPDATE_TIPO_DONACION = 'update_tipo_donacion';
export const CREATE_TIPO_DONACION = 'create_tipo_donacion';
export const DELETE_TIPO_DONACION = 'delete_tipo_donacion';

// PARAMETROS CORREOS
export const GET_COLECCION_PARAMETRO_CORREO = 'get_coleccion_parametro_correo';
export const GET_COLECCION_LIGERA_PARAMETRO_CORREO = 'get_coleccion_ligera_parametro_correo';
export const SHOW_PARAMETRO_CORREO = 'show_parametro_correo';
export const UPDATE_PARAMETRO_CORREO = 'update_parametro_correo';
export const CREATE_PARAMETRO_CORREO = 'create_parametro_correo';
export const DELETE_PARAMETRO_CORREO = 'delete_parametro_correo';

// PARAMETROS CONSTANTES
export const GET_COLECCION_PARAMETRO_CONSTANTE = 'get_coleccion_parametro_constante';
export const GET_COLECCION_LIGERA_PARAMETRO_CONSTANTE = 'get_coleccion_ligera_parametro_constante';
export const SHOW_PARAMETRO_CONSTANTE = 'show_parametro_constante';
export const UPDATE_PARAMETRO_CONSTANTE = 'update_parametro_constante';
export const CREATE_PARAMETRO_CONSTANTE = 'create_parametro_constante';
export const DELETE_PARAMETRO_CONSTANTE = 'delete_parametro_constante';

// DOCUMENTOS PROYECTO
export const GET_COLECCION_DOCUMENTOS_PROYECTO = 'get_coleccion_documentos_proyecto';
export const UPDATE_DOCUMENTOS_PROYECTO = 'update_documentos_proyecto';

// BITACORAS PROYECTO
export const GET_COLECCION_BITACORA_PROYECTO = 'get_coleccion_bitacora_proyecto';
export const GET_COLECCION_HEADERS_BITACORA = 'get_coleccion_headers_bitacora';
export const SHOW_BITACORA_PROYECTO = 'show_bitacora_proyecto';
export const UPDATE_BITACORA_PROYECTO = 'update_bitacora_proyecto';
export const CREATE_BITACORA_PROYECTO = 'create_bitacora_proyecto';
export const DELETE_BITACORA_PROYECTO = 'delete_bitacora_proyecto';

// ORIENTACIONES
export const GET_COLECCION_ORIENTACION = 'get_coleccion_orientacion';
export const SHOW_ORIENTACION = 'show_orientacion';
export const UPDATE_ORIENTACION = 'update_orientacion';
export const CREATE_ORIENTACION = 'create_orientacion';
export const DELETE_ORIENTACION = 'delete_orientacion';

// PLAN AMORTIZACION
export const GET_COLECCION_PLAN_AMORTIZACION = 'get_coleccion_plan_amortizacion';
export const GET_COLECCION_HEADERS_PLAN_AMORTIZACION = 'get_coleccion_headers_plan_amortizacion';

// PLAN AMORTIZACION DEFINITIVO
export const GET_COLECCION_PLAN_AMORTIZACION_DEFINITIVO = 'get_coleccion_plan_amortizacion_definitivo';
export const GET_COLECCION_HEADERS_PLAN_AMORTIZACION_DEFINITIVO = 'get_coleccion_headers_plan_amortizacion_definitivo';

// DONACIONES
export const GET_COLECCION_DONACION = 'get_coleccion_donacion';
export const GET_COLECCION_LIGERA_DONACION = 'get_coleccion_ligera_donacion';
export const SHOW_DONACION = 'show_donacion';
export const UPDATE_DONACION = 'update_donacion';
export const CREATE_DONACION = 'create_donacion';
export const DELETE_DONACION = 'delete_donacion';

// DESEMBOLSOS
export const GET_COLECCION_DESEMBOLSO = 'get_coleccion_desembolso';
export const GET_COLECCION_LIGERA_DESEMBOLSO = 'get_coleccion_ligera_desembolso';
export const SHOW_DESEMBOLSO = 'show_desembolso';
export const UPDATE_DESEMBOLSO = 'update_desembolso';
export const CREATE_DESEMBOLSO = 'create_desembolso';
export const DELETE_DESEMBOLSO = 'delete_desembolso';

// OTRO DESEMBOLSOS
export const GET_COLECCION_OTRO_DESEMBOLSO = 'get_coleccion_otro_desembolso';
export const GET_COLECCION_LIGERA_OTRO_DESEMBOLSO = 'get_coleccion_ligera_otro_desembolso';
export const SHOW_OTRO_DESEMBOLSO = 'show_otro_desembolso';
export const UPDATE_OTRO_DESEMBOLSO = 'update_otro_desembolso';
export const CREATE_OTRO_DESEMBOLSO = 'create_otro_desembolso';
export const DELETE_OTRO_DESEMBOLSO = 'delete_otro_desembolso';
export const SHOW_FECHA_EGRESO_DESEMBOLSO = 'show_fecha_egreso_desembolso';


// DESEMBOLSOS
export const GET_COLECCION_DESEMBOLSO_CUENTA_EGRESO = 'get_coleccion_desembolso_cuenta_egreso';
export const GET_COLECCION_LIGERA_DESEMBOLSO_CUENTA_EGRESO = 'get_coleccion_ligera_desembolso_cuenta_egreso';
export const SHOW_DESEMBOLSO_CUENTA_EGRESO = 'show_desembolso_cuenta_egreso';
export const UPDATE_DESEMBOLSO_CUENTA_EGRESO = 'update_desembolso_cuenta_egreso';
export const CREATE_DESEMBOLSO_CUENTA_EGRESO = 'create_desembolso_cuenta_egreso';
export const DELETE_DESEMBOLSO_CUENTA_EGRESO = 'delete_desembolso_cuenta_egreso';

// DESEMBOLSOS
export const GET_COLECCION_DESEMBOLSO_CUENTA_CONTABLE = 'get_coleccion_desembolso_cuenta_contable';
export const GET_COLECCION_LIGERA_DESEMBOLSO_CUENTA_CONTABLE = 'get_coleccion_ligera_desembolso_cuenta_contable';
export const SHOW_DESEMBOLSO_CUENTA_CONTABLE = 'show_desembolso_cuenta_contable';
export const UPDATE_DESEMBOLSO_CUENTA_CONTABLE = 'update_desembolso_cuenta_contable';
export const CREATE_DESEMBOLSO_CUENTA_CONTABLE = 'create_desembolso_cuenta_contable';
export const DELETE_DESEMBOLSO_CUENTA_CONTABLE = 'delete_desembolso_cuenta_contable';

// PAGOS
export const GET_COLECCION_PAGO = 'get_coleccion_pago';
export const GET_COLECCION_LIGERA_PAGO = 'get_coleccion_ligera_pago';
export const SHOW_PAGO = 'show_pago';
export const UPDATE_PAGO = 'update_pago';
export const CREATE_PAGO = 'create_pago';
export const DELETE_PAGO = 'delete_pago';

// PAGOS DETALLE
export const GET_COLECCION_PAGO_DETALLE = 'get_coleccion_pago_detalle';

// CALCULO MORA
export const EXECUTE_CALCULO_MORA = 'execute_calculo_mora';

// CONCEPTO
export const GET_COLECCION_CONCEPTO = 'get_coleccion_concepto';
export const GET_COLECCION_LIGERA_CONCEPTO = 'get_coleccion_ligera_concepto';
export const SHOW_CONCEPTO = 'show_concepto';
export const UPDATE_CONCEPTO = 'update_concepto';
export const CREATE_CONCEPTO = 'create_cconcepto';
export const DELETE_CONCEPTO = 'delete_concepto';

// CONCEPTO CUNETA CONTABLE
export const GET_COLECCION_CONCEPTO_CUENTA_CONTABLE = 'get_coleccion_concepto_cuenta_contable';
export const GET_COLECCION_LIGERA_CONCEPTO_CUENTA_CONTABLE = 'get_coleccion_ligera_concepto_cuenta_contable';
export const SHOW_CONCEPTO_CUENTA_CONTABLE = 'show_concepto_cuenta_contable';
export const UPDATE_CONCEPTO_CUENTA_CONTABLE = 'update_concepto_cuenta_contable';
export const CREATE_CONCEPTO_CUENTA_CONTABLE = 'create_concepto_cuenta_contable';
export const DELETE_CONCEPTO_CUENTA_CONTABLE = 'delete_concepto_cuenta_contable';

// CONCEPTO
export const GET_COLECCION_CUENTA_BANCARIA_DESEMBOLSO = 'get_coleccion_cuenta_bancaria_desembolso';
export const GET_COLECCION_LIGERA_CUENTA_BANCARIA_DESEMBOLSO = 'get_coleccion_ligera_cuenta_bancaria_desembolso';
export const SHOW_CUENTA_BANCARIA_DESEMBOLSO = 'show_cuenta_bancaria_desembolso';
export const UPDATE_CUENTA_BANCARIA_DESEMBOLSO = 'update_cuenta_bancaria_desembolso';
export const CREATE_CUENTA_BANCARIA_DESEMBOLSO = 'create_cuenta_bancaria_desembolso';
export const DELETE_CUENTA_BANCARIA_DESEMBOLSO = 'delete_cuenta_bancaria_desembolso';

// TERCERO
export const GET_COLECCION_TERCERO = 'get_coleccion_tercero';
export const GET_COLECCION_LIGERA_TERCERO = 'get_coleccion_ligera_tercero';
export const SHOW_TERCERO = 'show_tercero';
export const UPDATE_TERCERO = 'update_tercero';
export const CREATE_TERCERO = 'create_tercero';
export const DELETE_TERCERO = 'delete_tercero';